import { asthma } from '../../utils/data'
import QuizResultsModal from './QuizResultsModal'

export default {
    components: {
        QuizResultsModal
    },
    created() {
      window.addEventListener("resize", this.onResize);
    },
    destroyed() {
      window.removeEventListener("resize", this.onResize);
    },
    mounted() {
        this.isMounted = true;
    },
    delimiters: ['{(', ')}'],
    data() {
        return {
            showModal: false,
            scenarios: asthma.scenarios,
            isMounted: false,
            viewportWidth: window.innerWidth
        }
    },
    props: ['steps'],
    computed: {
        scenarioId() {
            return parseInt(''+this.steps['asthma-attack']+this.steps['gina']+this.steps['risk-factors']+this.steps['blood-eosinophil']+this.steps['feno'])
        },
        scenarioPrefix() {
            return parseInt(''+this.steps['asthma-attack']+this.steps['gina']+this.steps['risk-factors']);
        },
        scenarioSuffix() {
            return parseInt(''+this.steps['blood-eosinophil']+this.steps['feno']);
        },
        scenario() {
            return { ...this.scenarios[this.scenarioId], color: this.getScenarioColorById(this.scenarioId)}
        },
        arrowPath() {
            if(!this.isMounted) return;
            if(this.scenarioSuffix == '11' || this.scenarioSuffix == '10') return;

            const rows = this.steps['feno'] == 0 ? 1 : 3;

            const bcr = this.$refs['table-arrow'].getBoundingClientRect()
            const cellWidth = bcr.width/3;
            const cellHeight = bcr.height/rows;

            const origin = {
                x: this.steps['blood-eosinophil'],
                y: rows == 1 ? 0 : rows - this.steps['feno']
            }

            const target = {
                x: 1,
                y: rows == 1 ? 0 : 2
            }

            let originOffset;
            if(this.viewportWidth > 700) {
                originOffset = origin.x == 1 ? -cellWidth/4 : -cellWidth*3/4;
            } else {
                originOffset = origin.x == 1 ? -8 : -cellWidth + 8;
            }

            let targetOffset;
            if(this.viewportWidth > 700) {
                targetOffset = -cellWidth/4;
            } else {
                targetOffset = -8;
            }

            return `M${origin.x * cellWidth + originOffset},${origin.y * cellHeight + cellHeight/2 - 5} L${target.x * cellWidth + targetOffset},${target.y * cellHeight + cellHeight/2 - 5}`;
        }
    },
    methods: {
        originEndsWith(suffix) {
            return suffix == this.scenarioSuffix;
        },
        getScenarioColorById(id) {
            if(typeof id != 'string') id = id.toString()
            const trailingNumbers = id.substr(id.length-2, id.length)

            let color;
            switch(trailingNumbers) {
                case '12':
                case '11':
                case '10':
                    color = 'best';
                    break;
                case '13':
                case '22':
                case '21':
                case '20':
                    color = 'medium';
                    break;
                case '23':
                case '32':
                case '31':
                    color = 'bad';
                    break;
                case '33':
                case '30':
                    color = 'critical'
                    break;
            }

            return color
        },
        onResize() {
            this.viewportWidth = window.innerWidth;
        }
    }
}
